window.$ = window.jQuery = require('jquery');
require('./bootstrap');

import Quill from 'quill';
import htmlEditButton from "quill-html-edit-button";


if ($('.quill-editor').length > 0) {
    Quill.register("modules/htmlEditButton", htmlEditButton);
    var quill = new Quill('.quill-editor-input', {
        theme: 'snow',
        modules: {
            htmlEditButton: {}
        }
    });
    quill.on('text-change', function(delta, oldDelta, source) {
        var field_input = $(".quill-editor").data("field-to-update");
        console.log(field_input);
        $(field_input).val(quill.root.innerHTML);
    });
}

$('a.terminal-display').hover(
    function(){
    var method = $(this).data('terminal-display');
    $('.flare__terminal-display').text(method);
    },
    function(){
    $('.flare__terminal-display').text('');
    }
);

$('.alert a[href^="http"]').attr('target', '_blank');

$('.form-control').each(function() {
   var elem = $(this);

   // Save current value of element
   elem.data('oldVal', elem.val());

   // Look for changes in the value
   elem.bind("propertychange change click keyup input paste", function(event){
        // If value has changed...
        if (elem.data('oldVal') != elem.val()) {

            // Updated stored value
            elem.data('oldVal', elem.val());

            // Display action
            if (elem.attr('id') == 'password') {
               var form_action = "var " + elem.attr('name') + " = 'shhhhh...'";
            } else {
                var form_action = "var " + elem.attr('name') + " = '" + elem.val() + "'";
            }
            $('.flare__terminal-display').text(form_action);

        }
    });
});

$("select.form-control").on("click", function(e) {

    // Display action
    var elem = $(this);
    var form_action = "var " + elem.attr('name') + " = '" + elem.val() + "'";
    $('.flare__terminal-display').text(form_action);

});

(function() {

  var laravel = {
    initialize: function() {
      this.methodLinks = $('a[data-method]');

      this.registerEvents();
    },

    registerEvents: function() {
      this.methodLinks.on('click', this.handleMethod);
    },

    handleMethod: function(e) {

      var link = $(this);
      var httpMethod = link.data('method').toUpperCase();
      var form;

      // If the data-method attribute is not PUT or DELETE,
      // then we don't know what to do. Just ignore.
      if ( $.inArray(httpMethod, ['PUT', 'DELETE']) === - 1 ) {
        return;
      }

      // Allow user to optionally provide data-confirm="Are you sure?"
      if ( link.data('confirm') ) {
        if ( ! laravel.verifyConfirm(link) ) {
          return false;
        }
      }

      form = laravel.createForm(link);
      form.submit();

      e.preventDefault();
    },

    verifyConfirm: function(link) {
      return confirm(link.data('confirm'));
    },

    createForm: function(link) {
      var form =
      $('<form>', {
        'method': 'POST',
        'action': link.attr('href')
      });

      var token =
      $('<input>', {
        'type': 'hidden',
        'name': '_token',
          'value': link.data('token')
        });

      var hiddenInput =
      $('<input>', {
        'name': '_method',
        'type': 'hidden',
        'value': link.data('method')
      });

      return form.append(token, hiddenInput)
                 .appendTo('body');
    }
  };

  laravel.initialize();

})();

//TOOLTIPS
$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})

//Check if checkboxes are checked
function checkChecked(formname) {

    var cntCheck = 0;

    $('#' + formname + ' input[type="checkbox"]').each(function() {
        if ($(this).is(":checked")) {
            cntCheck++;
        }
    });

    if(cntCheck > 0) {
        //add padding
        $('body').addClass('footer-floater-padding');
        //show submit-floater
        $("#footer-floater" ).removeClass('d-none');
        $("#footer-floater" ).addClass('d-block');

        floaterHeight = $("#footer-floater").height();

    }

    if(cntCheck < 1) {
        //remove padding
        $('body').removeClass('footer-floater-padding');
        //hide submit-floater
        $("#footer-floater" ).removeClass('d-block');
        $("#footer-floater" ).addClass('d-none');
    }

}

checkChecked('mass-update-pages');

$("form.check-checked :input").change(function() {
    var formId = $(this).closest('form').attr('id');
    checkChecked(formId);
});

paneFormCheck();

$('button[data-bs-toggle="tab"]').on('shown.bs.tab', function (event) {

    paneFormCheck();

    var query_for_url = $(this).data('bs-target').replace('#','');

    var currentUrl = window.location.href;
    var currentTitle = window.location.title;
    var url = new URL(currentUrl);
    url.searchParams.set("section", query_for_url); // setting your param
    var newUrl = url.href;

    // This will create a new entry in the browser's history, without reloading
    window.history.pushState('', currentTitle, newUrl);

    // This will replace the current entry in the browser's history, without reloading
    window.history.replaceState('', currentTitle, newUrl);

})

//Disable hidden pane form inputs
function paneFormCheck() {

    $(".tab-pane").each(function( index ) {

        if($(this).hasClass("active")) {

            //enable form elements
            $(this).find('input').attr("disabled", false);
            $(this).find('textarea').attr("disabled", false);
            $(this).find('select').attr("disabled", false);

            //check for a conditional
            if($("input.checkbox-condition",this).length > 0) {

                //get info about what we're showing/hiding
                var checkbox = $("input.checkbox-condition",this);
                var show_hide_class = "." + $(checkbox).data('show-hide');
                var show_hide = $(show_hide_class,this);

                //set some defaults
                checkboxCondition(checkbox, show_hide);

                //react to changes
                checkbox.on('click', function() {
                    checkboxCondition(this, show_hide);
                });

            }

            //Select conditional
            if($("form select.select-conditional",this).length > 0) {
                $("form select.select-conditional",this).each(function(select) {
                    selectCondition(this);
                });
            }

        } else {

            //disable form elements
            $(this).find('input').attr("disabled", true);
            $(this).find('textarea').attr("disabled", true);
            $(this).find('select').attr("disabled", true);

        }

    });

}

function checkboxCondition(checkbox,show_hide) {
    if($(checkbox).is(':checked')) {
        show_hide.show();
        show_hide.find('input').attr('disabled', false);
    } else {
        console.log('here');
        show_hide.hide();
        show_hide.find('input').attr('disabled', true);
    }
}

if($("form select.select-conditional").length > 0) {
    console.log('here');
    $("form select.select-conditional").each(function(select) {
        selectCondition(this);
    });
}

$("form select.select-conditional").change(function() {
    selectCondition(this);
});

function selectCondition(select) {

    var current_option = $(select).val();
    var conditions = $(select).data('conditions');
    $.each(conditions, function(option,condition) {
        if(current_option == option) {
            $.each(condition.hide, function(key,field_to_hide) {
                $(field_to_hide).hide();
                $('input',field_to_hide).prop('disabled',true);
            });
            $.each(condition.show, function(key,field_to_hide) {
                $(field_to_hide).show();
                $('input',field_to_hide).prop('disabled',false);
            });
        }
    });
}
